// extracted by mini-css-extract-plugin
export var swiper_main = "styles-module--swiper_main--1S6cM";
export var swiper_btn = "styles-module--swiper_btn--1QnNW";
export var swiper_pagin = "styles-module--swiper_pagin--3O7hd";
export var swiperWrapper = "styles-module--swiperWrapper--2U6BZ";
export var jsAnimInit = "styles-module--jsAnimInit--15jXu";
export var swiperWrap = "styles-module--swiperWrap--1s94y";